import React from "react";
import { FormLabel, Grid } from "@mui/material";
import NumberEditor from "../inputs/numberEditor";
import { GetLineItemPrecision } from "../../sharedCode/HelperMethods";
import Box from "@mui/material/Box";
import { TicketLineItemExtended } from "../../Utils/TypeExtensions";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";

interface Props extends TicketProps {
    lineItemTypeId: number;
    mergeRowChanges: (lineItemId: number, changes: Record<string, unknown>) => void;
}

export default function MinimumsRow(props: Props): JSX.Element {
    const col1width = 10.0;
    const col2width = 2.0;

    const lineItem = props.ticket.LineItems?.find((item) => item?.line_item_type_id === props.lineItemTypeId) as TicketLineItemExtended;
    const lineItemType = props.lineItemTypeList.find((t) => t.id === props.lineItemTypeId);

    if (!lineItem || !lineItemType) return <></>;

    return (
        <Grid container flexDirection={"row"} spacing={1} alignItems={"center"}>
            <Grid xs={col1width} item>
                <Box flexDirection={"row"} sx={{ ml: 2.0, mt: 1.8, mb: 1.4, width: "100%" }}>
                    <FormLabel>{lineItemType.label.toLocaleUpperCase()}</FormLabel>
                </Box>
            </Grid>
            <Grid xs={col2width} item>
                <NumberEditor
                    sourceId={lineItem.id}
                    sourceProperty="amount"
                    labelText="HOURS"
                    isRequired={false}
                    initialValue={lineItem.amount}
                    mergeChanges={props.mergeRowChanges}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/minimums"}
                    precision={GetLineItemPrecision(props.lineItemTypeId)}
                />
            </Grid>
        </Grid>
    );
}
